
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { BaseService } from "./base.service";
import { HttpParams } from "@angular/common/http";
//own
import { Session } from "./models/session.model";
import { CookieService } from 'ng2-cookies'
import { HttpHeaders } from "@angular/common/http";

const COOKIE_NAME_ACCESS_TOKEN: string = "accessToken";
const COOKIE_NAME_CLAM_ID: string = "claimId";
const COOKIE_NAME_AVATAR_HASH: string = "avatarHash";
const COOKIE_NAME_USER_NAME: string = "userName";
const COOKIE_NAME_NAME: string = "name";
const COOKIE_NAME_EMAIL: string = "eMail";
const COOKIE_NAME_IS_CONTRACT_ACTIVE: string = "isContractActive";
const COOKIE_NAME_IS_EXTRAS_AVIABLE: string = "isExtrasAvailable";
const COOKIE_CURRENT_USER_ID: string = "CurrentUserId";

const CLAIM_SUPER_ADMIN: string = "sa";
const CLAIM_ADMIN: string = "admin";
const CLAIM_STD: string = "std";

const TOKEN_TYPE: string = "PROMOTOR-AES-1 ";

@Injectable()
export class PublicService extends BaseService {

  constructor(private httpClient: HttpClient,
    private cookieService: CookieService) {
    super();
  }

  protected getBasePath(): string {
    return super.getBasePath() + "public/";
  }

  public _GetBasePath() {
    return super.getBasePath();
  }
  //methods user
  public login(email: string, password: string): Observable<Session> {
    //  console.log(this.getBasePath())
    var body = JSON.parse('{"email":"' + email + '","password":"' + password + '"}');
    var url = this.getBasePath() + "login";
    //console.log("looooogiiiiin " + url);
    //console.log(body);
    //console.log(this.httpClient.post<Session>(url, body));
    return this.httpClient.post<Session>(url, body);
  }

  public CompleteResotrePassword(password: string, passwordRep: string, token: string) {

    var body = {
      newPassword: password,
      newPassword2: passwordRep,
      token: token,
    }

    var url = this.getBasePath() + "CompleteRestorePassword/";
    return this.httpClient.post(url, body, { responseType: 'text' });
  }

  public CompleteRegister(password: string, passwordRep: string, token: string) {
    var body = {
      newPassword: password,
      newPassword2: passwordRep,
      token: token,
    }

    var url = this.getBasePath() + "CompleteRegister/";
    return this.httpClient.post(url, body, { responseType: 'text' });
  }

  public StartResotrePassword(email: string) {
    var url = this.getBasePath() + "RestorePassword/";
    let p: HttpParams = new HttpParams().set("email", email);
    let h: HttpHeaders = new HttpHeaders({ contentType: 'text' });

    return this.httpClient.get(url, { headers: h, params: p, responseType: 'text' });
  }

  public SendMassiveEmails(emails) {
    var url = this.getBasePath() + emails;
    //let p: HttpParams = new HttpParams().set("email", email);
    //let h: HttpHeaders = new HttpHeaders({ contentType: 'text' });

    return this.httpClient.get(url, { responseType: 'text' });
  }

  public getAvatar(avatarHash: string): string {
    return this.getBasePath() + "/GetAvatar?avatarHash=" + avatarHash;
  }

  //methods Cookies
  private removeAllCookies() {
    this.cookieService.deleteAll();
  }

  public logout() {
    this.removeAllCookies();
  }

  public setAccessToken(accessToken: string) {
    this.cookieService.set(COOKIE_NAME_ACCESS_TOKEN, accessToken);
  }

  public getAccessToken(): string {
    return this.cookieService.get(COOKIE_NAME_ACCESS_TOKEN);
  }

  public getTokenType(): string {
    return TOKEN_TYPE;
  }

  public setClaim(claim: string) {
    this.cookieService.set(COOKIE_NAME_CLAM_ID, claim);
  }

  public isStandard(): boolean {
    return this.getClamId() == CLAIM_STD ? true : false;
  }

  public isAdmin(): boolean {
    return this.getClamId() == CLAIM_ADMIN ? true : false;
  }

  public isSuperAdmin(): boolean {
    return this.getClamId() == CLAIM_SUPER_ADMIN ? true : false;
  }

  public getClamId(): string {
    return this.cookieService.get(COOKIE_NAME_CLAM_ID);
  }

  public setAvatarHash(hash: string) {
    this.cookieService.set(COOKIE_NAME_AVATAR_HASH, hash);
  }

  public getAvatarHash(): string {
    return this.cookieService.get(COOKIE_NAME_AVATAR_HASH);
  }

  public setUserName(username: string) {
    this.cookieService.set(COOKIE_NAME_USER_NAME, username);
  }

  public getUserName(): string {
    return this.cookieService.get(COOKIE_NAME_USER_NAME);
  }

  public setName(name: string) {
    this.cookieService.set(COOKIE_NAME_NAME, name);
  }

  public getName(): string {
    return this.cookieService.get(COOKIE_NAME_NAME);
  }

  public setEMail(mail: string) {

    this.cookieService.set(COOKIE_NAME_EMAIL, mail);
  }

  public getEMail(): string {
    return this.cookieService.get(COOKIE_NAME_EMAIL);
  }

  public setIsContractActive(isContractActive: string) {
      
      this.cookieService.set(COOKIE_NAME_IS_CONTRACT_ACTIVE, isContractActive);
      //console.log(isContractActive)
  }

  public getIsContractActive(): string {
     // console.log("isActiveEntra");
      //console.log(COOKIE_NAME_IS_CONTRACT_ACTIVE);
    return this.cookieService.get(COOKIE_NAME_IS_CONTRACT_ACTIVE);
  }

  public setIsExtrasAvaiable(isExtrasAviable: string) {
    this.cookieService.set(COOKIE_NAME_IS_EXTRAS_AVIABLE, isExtrasAviable);
  }

  public getIsExtrasAvaiable(): string {
    return this.cookieService.get(COOKIE_NAME_IS_EXTRAS_AVIABLE);
  }

  public setCurrnetUserId(idCurrentUser: string) {
    this.cookieService.set(COOKIE_CURRENT_USER_ID, idCurrentUser);
  }

  public getCurrnetUserId():string {
    return this.cookieService.get(COOKIE_CURRENT_USER_ID);
  }

  public isAuthenticated(): Promise<any> {
    return new Promise(
      (resolve, reject) => {
        resolve(this.getAccessToken() != null && this.getAccessToken() != "")
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/services/public.service.ts